/**
 * Общая палитра классов UI-kit (HeroUI).
 * Все значения — ПОЛНЫЕ литералы классов hui-*, чтобы Tailwind не вычистил их в prod
 * (файл попадает в content-скан как shared/**\/*.ts). Хардкод hex запрещён —
 * источник цвета только assets/css/ui-kit/tokens.css.
 */
export type HuiColor = 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger'
export type HuiSize = 'sm' | 'md' | 'lg'

export const HUI_COLORS: HuiColor[] = ['default', 'primary', 'secondary', 'success', 'warning', 'danger']

/** Сплошная заливка цветом (фон) */
export const BG: Record<HuiColor, string> = {
  default: 'bg-hui-default',
  primary: 'bg-hui-primary',
  secondary: 'bg-hui-secondary',
  success: 'bg-hui-success',
  warning: 'bg-hui-warning',
  danger: 'bg-hui-danger',
}

/** Граница цветом */
export const BORDER: Record<HuiColor, string> = {
  default: 'border-hui-default',
  primary: 'border-hui-primary',
  secondary: 'border-hui-secondary',
  success: 'border-hui-success',
  warning: 'border-hui-warning',
  danger: 'border-hui-danger',
}

/** Текст цветом (для default — читаемый foreground вместо светло-серого) */
export const TEXT: Record<HuiColor, string> = {
  default: 'text-hui-default-foreground',
  primary: 'text-hui-primary',
  secondary: 'text-hui-secondary',
  success: 'text-hui-success',
  warning: 'text-hui-warning',
  danger: 'text-hui-danger',
}

/** Текст на сплошной заливке (контрастный foreground) */
export const TEXT_FG: Record<HuiColor, string> = {
  default: 'text-hui-default-foreground',
  primary: 'text-hui-primary-foreground',
  secondary: 'text-hui-secondary-foreground',
  success: 'text-hui-success-foreground',
  warning: 'text-hui-warning-foreground',
  danger: 'text-hui-danger-foreground',
}

/** Цвет фокус-кольца (используется вместе с focus-visible:ring-2 в базе компонента) */
export const RING: Record<HuiColor, string> = {
  default: 'focus-visible:ring-hui-default',
  primary: 'focus-visible:ring-hui-primary',
  secondary: 'focus-visible:ring-hui-secondary',
  success: 'focus-visible:ring-hui-success',
  warning: 'focus-visible:ring-hui-warning',
  danger: 'focus-visible:ring-hui-danger',
}

/** Граница при фокусе внутри (для инпутов/селектов) */
export const FOCUS_BORDER: Record<HuiColor, string> = {
  default: 'focus-within:border-hui-default-foreground',
  primary: 'focus-within:border-hui-primary',
  secondary: 'focus-within:border-hui-secondary',
  success: 'focus-within:border-hui-success',
  warning: 'focus-within:border-hui-warning',
  danger: 'focus-within:border-hui-danger',
}
